const spreadSx = (sx) => Array.isArray(sx) ? sx : sx ? [sx] : [];
export {
  spreadSx
};
//# sourceMappingURL=spreadSx.js.map
